module.exports = __webpack_public_path__ + "img/icon_googleplay.8412cc2c.png";